export enum ResourceIntent {
  ROUTE = 'route',
  REGISTRATION = 'registration'
}
